import {CompressedLabelsToken} from '@github-ui/item-picker-base/CompressedLabelsToken'
import {HOTKEYS} from '@github-ui/item-picker-base/constants/hotkeys'
import {LABELS} from '@github-ui/item-picker-base/constants/labels'
import {TagIcon} from '@primer/octicons-react'
import type React from 'react'
import {forwardRef} from 'react'

import type {ItemPickerLabelItem} from './ItemPickerLabelBase'

type CompressedLabelAnchorProps = {
  size?: 'small' | 'large'
  labels: ItemPickerLabelItem[]
  anchorProps?: React.HTMLAttributes<HTMLElement>
  displayHotkey: boolean
  MAX_DISPLAYED_LABELS?: number
  readonly?: boolean
}

export const CompressedLabelAnchor = forwardRef<HTMLButtonElement, CompressedLabelAnchorProps>(
  ({size = 'small', labels, anchorProps, displayHotkey, MAX_DISPLAYED_LABELS = 2, readonly}, ref) => {
    return (
      <CompressedLabelsToken
        size={size}
        labelNamesWithColor={labels.map(l => ({nameHTML: l.nameHTML, color: l.color}))}
        anchorProps={anchorProps}
        MAX_DISPLAYED_LABELS={MAX_DISPLAYED_LABELS}
        readonly={readonly}
        leadingIcon={TagIcon}
        hotKey={!readonly && displayHotkey ? HOTKEYS.labelPicker.toUpperCase() : undefined}
        anchorText={labels?.length === 0 ? LABELS.noLabels : undefined}
        ref={ref}
      />
    )
  },
)

CompressedLabelAnchor.displayName = 'CompressedLabelAnchor'

type DefaultLabelPickerAnchorProps = {
  labels: ItemPickerLabelItem[]
  readonly: boolean
  anchorProps?: React.HTMLAttributes<HTMLElement> | undefined
}

export const DefaultLabelPickerAnchor = forwardRef<HTMLButtonElement, DefaultLabelPickerAnchorProps>(
  ({labels, readonly, anchorProps}, ref) => {
    return (
      <CompressedLabelAnchor
        labels={labels}
        readonly={readonly}
        displayHotkey={false}
        anchorProps={readonly ? undefined : anchorProps}
        ref={ref}
      />
    )
  },
)

DefaultLabelPickerAnchor.displayName = 'DefaultLabelAnchor'
